





































import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class SubmissionFormSubmissionDialog extends Vue {
  @Prop() private id!: string;
  @Prop() private uploading!: boolean;
  @Prop() private uploadProgress!: number;
  @Prop() private attachmentsUploaded!: number;
  @Prop() private attachmentsCount!: number;
  @Prop() private message!: string;
  @Emit()
  confirmSubmission(e: Event) {
    return e.target;
  }
}
